import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Box from '../components/Box'
import LoadingProgress from '../components/LoadingProgress'
import ErrorMessage from '../components/ErrorMessage'
import { fetchPersistedSalesArqueos, fetchPersistedOperationalArqueos, generateArqueosRange } from '../actions/arqueos'

class ArqueosDashboardView extends React.Component {
  constructor(props) {
    super(props)
    const today = new Date()
    const prior = new Date()
    prior.setDate(today.getDate() - 13) // default 14-day window
    this.state = {
      startDate: prior.toISOString().slice(0, 10),
      endDate: today.toISOString().slice(0, 10),
      loading: false,
      generateLoading: false,
      lastResult: null
    }
  }

  componentDidMount() {
    this.fetchAll()
  }

  fetchAll = () => {
    const { startDate, endDate } = this.state
    this.setState({ loading: true })
    Promise.all([
      this.props.fetchPersistedSalesArqueos(startDate, endDate),
      this.props.fetchPersistedOperationalArqueos(startDate, endDate)
    ])
      .then(() => this.setState({ loading: false }))
      .catch(() => this.setState({ loading: false }))
  }

  generateMissing = () => {
    const { startDate, endDate } = this.state
    this.setState({ generateLoading: true })
    this.props.generateArqueosRange(startDate, endDate)
      .then(res => {
        this.setState({ generateLoading: false, lastResult: res })
        // refresh after generation
        this.fetchAll()
      })
      .catch(() => this.setState({ generateLoading: false }))
  }

  dayStatus(dayISO) {
    const { generatedSalesArqueos, generatedOperationalArqueos } = this.props
    const salesPresent = Array.isArray(generatedSalesArqueos) && generatedSalesArqueos.some(s => (s.Day || '').slice(0, 10) === dayISO)
    const opPresent = Array.isArray(generatedOperationalArqueos) && generatedOperationalArqueos.some(o => (o.Day || '').slice(0, 10) === dayISO)

    if (salesPresent && opPresent) return { color: 'green', label: 'OK' }
    if (salesPresent || opPresent) return { color: 'orange', label: 'Partial' }
    return { color: 'red', label: 'Missing' }
  }

  renderCalendar() {
    const { startDate, endDate } = this.state
    const start = new Date(startDate)
    const end = new Date(endDate)
    const days = []
    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
      days.push(new Date(d))
    }

    return (
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {days.map(d => {
          const iso = d.toISOString().slice(0, 10)
          const status = this.dayStatus(iso)
          return (
            <div key={iso} style={{ width: 110, margin: 6 }}>
              <div style={{ padding: 8, borderRadius: 4, background: '#fff', border: '1px solid #ddd' }}>
                <div style={{ fontSize: 12, color: '#666' }}>{iso}</div>
                <div style={{ marginTop: 8, fontWeight: '600', color: status.color }}>{status.label}</div>
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  render() {
    const { loading, startDate, endDate, generateLoading, lastResult } = this.state
    const { error, generatedSalesArqueos, generatedOperationalArqueos, role } = this.props

    if (role !== 'ADMIN') {
      return <ErrorMessage message="Not authorized" />
    }

    return (
      <div>
        <h3>Arqueos dashboard (admin) 🔧</h3>

        <Box>
          <div className="form-row">
            <div className="col-md-3 mb-2">
              <label>Start date</label>
              <input type="date" className="form-control" value={startDate}
                onChange={e => this.setState({ startDate: e.target.value })} />
            </div>
            <div className="col-md-3 mb-2">
              <label>End date</label>
              <input type="date" className="form-control" value={endDate}
                onChange={e => this.setState({ endDate: e.target.value })} />
            </div>
            <div className="col-md-6 mb-2" style={{ display: 'flex', alignItems: 'flex-end' }}>
              <button className="btn bg-vw-dark text-white mr-2" onClick={this.fetchAll} disabled={loading}>
                {loading ? 'Loading...' : 'Fetch generated arqueos'}
              </button>
              <button className="btn btn-outline-primary" onClick={this.generateMissing} disabled={generateLoading}>
                {generateLoading ? 'Generating...' : 'Generate range (call lambda)'}
              </button>
            </div>
          </div>

          <hr />

          {error && <ErrorMessage message={error.message} />}

          {loading ? <LoadingProgress /> : (
            <>
              <h5>Calendar</h5>
              {this.renderCalendar()}

              <div style={{ marginTop: 16 }}>
                <strong>Sales records:</strong> {Array.isArray(generatedSalesArqueos) ? generatedSalesArqueos.length : 0}
                {' — '}
                <strong>Operational records:</strong> {Array.isArray(generatedOperationalArqueos) ? generatedOperationalArqueos.length : 0}
              </div>

              {lastResult && (
                <div className="alert alert-info mt-3">
                  <strong>Generate result:</strong>
                  <pre style={{ maxHeight: 200, overflow: 'auto' }}>{JSON.stringify(lastResult, null, 2)}</pre>
                </div>
              )}
            </>
          )}
        </Box>

      </div>
    )
  }
}

const mapStateToProps = state => ({
  generatedSalesArqueos: state.arqueos.generatedSalesArqueos,
  generatedOperationalArqueos: state.arqueos.generatedOperationalArqueos,
  error: state.arqueos.error,
  role: state.auth.role
})

const mapDispatchToProps = dispatch => bindActionCreators({ fetchPersistedSalesArqueos, fetchPersistedOperationalArqueos, generateArqueosRange }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ArqueosDashboardView)
